import React, { createContext, useContext, ReactNode, useState } from 'react';

// Define the context shape
interface SelectionDate {
  startDate: string | null;
  endDate: string | null;
}

interface UtilContextProps {
  selectionDate: SelectionDate;
  setSelectionDate: (date: SelectionDate) => void;
  selectedType: string | null;
  setSelectedType: (type: string | null) => void;
}

// Create the context with default values
const UtilContext = createContext<UtilContextProps>({
  selectionDate: { startDate: null, endDate: null },
  setSelectionDate: () => {},
  selectedType: null,
  setSelectedType: () => {},
});

// Define the provider props
interface UtilProviderProps {
  children: ReactNode;
}

// Create the provider component
export const UtilProvider: React.FC<UtilProviderProps> = ({ children }) => {
  const [selectionDate, setSelectionDate] = useState<SelectionDate>({
    startDate: null,
    endDate: null,
  });

  const [selectedType, setSelectedType] = useState<string | null>(null);

  return (
    <UtilContext.Provider
      value={{
        selectionDate,
        setSelectionDate,
        selectedType,
        setSelectedType,
      }}
    >
      {children}
    </UtilContext.Provider>
  );
};

// Custom hook to access the context
export const useUtil = (): UtilContextProps => useContext(UtilContext);
